/**
 *
 * @param array to replace empty slots
 * @param replacement the value to replace the empty slots with, by default is an empty string
 * @returns the array with empty slots replaced with the replacement value
 */

export function replaceEmptySlots<T>(array: T[], replacement = ''): T[] {
  for (let i = 0; i < array.length; i++) {
    if (array[i] === undefined) {
      array[i] = replacement as T;
    }
  }
  return array;
}
